import React, { Component } from "react";
import { connect } from "react-redux";
import { SelectBox } from 'devextreme-react/select-box';
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import { withSnackbar } from 'notistack';
import { injectIntl } from "react-intl";
import * as companiesCrud from '../../../../crud/companies.crud';
import * as companiesDuck from '../../../../store/ducks/companies.duck';
import * as authDuck from '../../../../store/ducks/auth.duck';
import ImageEditor from '../../../../partials/content/ImageEditor';
import { confirm } from 'devextreme/ui/dialog';
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";

class CustomizeTheme extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            companyid: 0,
            companyPicture: null,
            theme: null
        };

        this.handleDownload = this.handleDownload.bind(this);
        this.handleImport = this.handleImport.bind(this);
        this.fileInputRef = React.createRef(); // Ref for the hidden file input
    }

    componentDidMount() {
        this.getCompanyTheme();
        this.props.loadCompanies();
    }

    getCompanyTheme = async () => {
        const { data: companyTheme } = await companiesCrud.getCompanyTheme(this.state.companyid);
        
        //const theme = this.state.companyid > 0 ? (companyTheme?.CUSTOM_THEME ?? companyTheme?.GLOBAL_THEME) : companyTheme?.GLOBAL_THEME;
        const theme = companyTheme?.themevalue;

        this.setState({ theme });
    }

    onValueChanged = (e) => {
        if (e.value) {
            this.setState({ companyid: e.value }, () => {
                this.getCompanyTheme();
                this.getCompanyPicture();
            });
        } else {
            this.setState({ companyid: 0 });
        }
    }

    getCompanyPicture = async () => {
        try {
            const companyPicture = (await companiesCrud.getCompanyPicture(this.state.companyid)).data;
            this.setState({ companyPicture });
        } catch (err) {
            this.props.enqueueSnackbar("Error fetching companyPicture: " + err.toString(), { variant: 'error', });
        }
    }

    // --- 3. DOWNLOAD (EXPORT) FUNCTION ---
    handleDownload() {
        //const jsonString = JSON.stringify(this.props.userProfile.companycustomthemejson, null, 2);
        const jsonString = this.state.theme;
        const blob = new Blob([jsonString], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        
        const a = document.createElement('a');
        a.href = url;
        a.download = 'custom-theme-config.json';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    // --- 4. IMPORT (UPLOAD) FUNCTION ---
    handleImport(event) {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const rawJson = e.target.result;
                const parsedJson = JSON.parse(rawJson);

                // Basic validation
                if (this.validateTemplate(parsedJson)) {
                    let companyTheme = {};
                    companyTheme.companyid = this.state.companyid;
                    companyTheme.themekey = this.state.companyid ? 'CUSTOM_THEME' : 'GLOBAL_THEME';
                    companyTheme.themevalue = rawJson;

                    companiesCrud.saveCompanyTheme(companyTheme)
                        .then(() => {
                            this.props.enqueueSnackbar('Theme updated successfully', { variant: 'success', });
                            this.props.refreshProfile();
                        })
                        .catch(err => {
                            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                        });
                } else {
                    alert("Error: Imported file has an invalid theme structure.");
                }
            } catch (error) {
                alert("Error parsing JSON file. Please ensure the file is valid.");
                console.error("Import error:", error);
            } finally {
                // CRITICAL FIX: Reset the input value after processing is complete.
                // This ensures that onChange fires even if the same file is selected again.
                event.target.value = null; 
            }
        };
        reader.readAsText(file);
    }

    validateTemplate = (file) => {
        if (file) {
            if (file.attributes) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    imageChangeHandler = async (event) => {
        try {
            if (event.target.files[0] && event.target.files[0].name) {
                if (event.target.files[0].name.endsWith('.jpeg') ||
                    event.target.files[0].name.endsWith('.png') ||
                    event.target.files[0].name.endsWith('.JPEG') ||
                    event.target.files[0].name.endsWith('.PNG')
                ) {

                    //THIS IS ONLY FOR SYSTEM OWNER
                    if (!this.state.companyPicture.isReplacement) {
                    ///USER CONFIRMATION
                    //LOGO CHANGE IS DANGEREOUS CHANGE
                    const userConfirmationResult = await confirm(
                        this.props.intl.formatMessage({ id: "COMPANY.WARNING.CHANGE_LOGO" }),
                        this.props.intl.formatMessage({ id: "COMPANY.WARNING.CHANGE_LOGO_LABEL" })
                    );

                    if (!userConfirmationResult) {
                        //CANCEL UPDATE
                        event.preventDefault();
                        event.target.value = null;
                        return;
                    }
                    }          

                    companiesCrud.setCompanyPicture(this.state.companyid, event.target.files[0])
                    .then(() => {
                        this.props.enqueueSnackbar('Picture uploaded successfully', { variant: 'success', })
                        this.getCompanyPicture();
                    })
                    .catch(err => {
                        let errMessage = 'Error uploading!  ';
                        if (err.response) {
                            if (err.response.status && err.response.statusText) {
                                errMessage += '\n' + err.response.status + '-' + err.response.statusText;
                            }
                            if (err.response.data && err.response.data.ExceptionMessage) {
                                errMessage += '  \n "' + err.response.data.ExceptionMessage + '"';
                                //Error writing MIME multipart body part to output stream
                                //https://stackoverflow.com/questions/24196280/error-writing-mime-multipart-body-part-to-output-stream
                                // probably file exist in server folder !!
                            }
                        }
                        this.props.enqueueSnackbar(errMessage, { variant: 'error', });

                    });
                }
                else {
                    this.props.enqueueSnackbar('Only .png and .jpeg image extensions are supported', { variant: 'warning', });
                }
            }
        }
        catch { }
        finally {
            event.target.value = null;
        }
    }
    render() {
        if (!this.props.companies) {
            return <PortletSpinner />;
        }

        const { allowChangeLogo } = this.props.protectedRouteProps;
        let canChangeLogo = allowChangeLogo && (this.state.companyPicture?.isReplacement || (!this.state.companyPicture?.isReplacement && this.props.userProfile.accounttype === "System Owner"));

        //THIS IS A TEMPORARY CHANGE. WILL BE REMOVED IN THE NEXT SPRINT
        if ((process.env.REACT_APP_PRODUCT_KEY === "NG" || process.env.REACT_APP_PRODUCT_KEY === "NGEASTERNGREENLINK") && (process.env.REACT_APP_ENVIRONMENT === 'UAT' || process.env.REACT_APP_ENVIRONMENT === 'PROD')) {
            canChangeLogo = this.props.userProfile.accounttype === "System Owner";
        }

        return (
            <Portlet>
                <PortletHeader resource="SYSTEMSETTINGS.CUSTOMIZETHEME.TITLE" />
                <PortletBody style={{ maxWidth: 800 }}>
                    <div className="form">
                        {/* <ValidationGroup ref={this.validatorRef} name="AddBulkContractUserValidator"> */}
                            <div className="dx-fieldset">
                                <div className="dx-field">
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        {/* <div style={{ width: '245px', height: '245px' }}>
                                            <ImageEditor src={this.state.companyPicture.image} fileChangeHandler={this.imageChangeHandler} allowChangeLogo={canChangeLogo} />
                                        </div> */}
                                        <SelectBox
                                            dataSource={this.props.companies}
                                            valueExpr="companyid"
                                            displayExpr="name"
                                            showClearButton={true}
                                            // searchEnabled={true}
                                            // searchMode="contains"
                                            // searchExpr="name"
                                            // searchTimeout={200}
                                            // minSearchLength={0}
                                            // showDataBeforeSearch={true}
                                            //onValueChanged={(e) => { this.setCompanyFields(e.value); }}
                                            //onValueChanged={(e) => { this.onValueChanged(e.value); }}
                                            onValueChanged={this.onValueChanged}
                                            placeholder="Select a Company"
                                            //value={this.state.companyid}
                                            width={600}
                                        />
                                    </div>
                                </div>
                                <div className="dx-field">

                                </div>
                                {
                                    (this.state.companyid > 0 && this.state.companyPicture) && (
                                        <div className="dx-field">
                                            <div className="kt-portlet kt-portlet--height-fluid-" style={{ width: "100%", minWidth:50 }}>
                                                <div className="kt-portlet__body kt-portlet__body--fit-y" style={{ padding: '5px' }}>
                                                    <div className="kt-widget kt-widget--user-profile-1">
                                                        <div className="kt-widget__body" >
                                                            <div className="kt-widget__content" style={{ display: 'flex', justifyContent: 'center' }}>
                                                                <div style={{ width: '245px', height: '245px' }}>
                                                                    <ImageEditor src={this.state.companyPicture.image} fileChangeHandler={this.imageChangeHandler} allowChangeLogo={canChangeLogo} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                
                                <div className="dx-field">
                                    <div className="dx-field-label" style={{ width: "25%" }}>{this.props.intl.formatMessage({ id: "SYSTEMSETTINGS.CUSTOMIZETHEME.TITLE" })}:</div>
                                    <div className="dx-field-value" style={{ width: "75%" }}>
                                        <div>
                                            {/* Download Button */}
                                            <button 
                                                onClick={this.handleDownload}
                                                //disabled={!this.state.companyid}
                                                style={{ marginRight: '10px', padding: '10px'/*, backgroundColor: 'purple', color: 'white'*/ }}
                                            >
                                                Download Theme Template (.json)
                                            </button>

                                            {/* Import Button (Hidden File Input) */}
                                            <label htmlFor="theme-upload-input">
                                            <button 
                                                onClick={() => this.fileInputRef.current.click()} // Use the ref to trigger click
                                                //disabled={!this.state.companyid}
                                                style={{ padding: '10px'/*, backgroundColor: 'darkorange', color: 'white'*/ }}
                                            >
                                                Import Theme (.json)
                                            </button>
                                            </label>
                                            <input 
                                                ref={this.fileInputRef} // Attach the ref
                                                id="theme-upload-input"
                                                type="file" 
                                                accept=".json" 
                                                onChange={this.handleImport} 
                                                style={{ display: 'none' }} 
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        {/* </ValidationGroup> */}
                    </div>
                </PortletBody>
            </Portlet>
        )
    }
}

const mapStateToProps = (store) => ({
    company: store.company.company,
    companies: store.companies.companies,
    userProfile: store.auth.userProfile
});

const mapDispatchToProps = {
    loadCompanies: companiesDuck.actions.fetchStart,
    refreshProfile: authDuck.actions.refreshProfile
}

export default injectIntl(withSnackbar(connect(mapStateToProps, mapDispatchToProps)(CustomizeTheme)));